export default {"src":"/_next/static/media/youtube.07154289.svg","height":17,"width":24,"blurWidth":0,"blurHeight":0};